import { parentUrlParam } from '@/app.config'
import { getParentDomain, isCRMLoginPage } from '@/store/util'

export function setWithExpiry(key, value, hash = null) {
  const now = new Date()

  const item = {
    sessionId: value,
    expiry: now.getTime() + 3600000 // expires after 1 hour
  }

  if (hash) {
    item['hash'] = hash
  }

  sessionStorage.setItem(key, JSON.stringify(item))
}

export function getWithExpiry(key, hash = null) {
  const parentDomain = getParentDomain()

  const urlWithoutParentDomain = parentUrlParam.replace(parentDomain, '')
  if (
    isCRMLoginPage(urlWithoutParentDomain) ||
    parentDomain.endsWith('b4u-services.de') ||
    parentDomain.endsWith('b4u-cloud.de') ||
    parentDomain.endsWith('aareon.com')
  ) {
    sessionStorage.removeItem(key)
    return null
  }
  const itemStr = sessionStorage.getItem(key)
  if (!itemStr) {
    return null
  }
  const item = JSON.parse(itemStr)
  const now = new Date()

  if (hash && item.hash && hash !== item.hash) {
    global.log.info(
      'Hash mismatch, removing session so a new conversation will be started'
    )
    sessionStorage.removeItem(key)
    return null
  } else if (now.getTime() > item.expiry) {
    sessionStorage.removeItem(key)
    return null
  }

  return item.sessionId
}
